import { useSelector } from "react-redux";
import Loader from "../../../../shared/loader/Loader";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useEffect, useState } from "react";
import PagesUsed from "../../../../PrintActivity/PagesUsed/PagesUsed";
import { SUCCESS } from "../../../../../constants/AppConstants";

const EcoProPrintHistory = (props) => {
    const { t } = useTranslation("CSAgenttranslation");
    const printActivityResult = useSelector((state) => state.PrintActivity);
    const TABS = {
        'PRINT_HISTORY': 'PRINT_HISTORY'
    }
    const [activeTab, setActiveTab] = useState((printActivityResult?.printActivity?.devicePrintHistory?.length > 0)
        ? printActivityResult?.printActivity?.devicePrintHistory[0].deviceId
        : null);
    const [selectedDevicePrintHistoryArray, setSelectedDevicePrintHistoryArray] = useState(null);
    const [isDateFilterApplied, setIsDateFilterApplied] = useState(false);

    const [pagesUsedData, setPagesUsedData] = useState({
        planName: null,
        planPages: 0,
        printedPlanPages: 0,
        printedTotalPages: 0,
        printedRolloverPages: 0,
        givenRolloverPages: 0,
        printedOveragePages: 0,
        purchasedOveragePages: 0,
        printedBonusPages: 0,
        remainingBonusPages: 0
    })

    useEffect(() => {
        if (printActivityResult && printActivityResult?.printActivity?.actionStatus?.toUpperCase() === SUCCESS) {
            if (printActivityResult?.printActivity?.devicePrintHistory?.length > 0) {
                setActiveTab(printActivityResult?.printActivity?.devicePrintHistory[0]?.deviceId);
                setSelectedDevicePrintHistoryArray(printActivityResult?.printActivity?.devicePrintHistory[0]?.printHistory);
                setIsDateFilterApplied(false);
            }
            else {
                setActiveTab(TABS.PRINT_HISTORY)
            }
        }
    }, [TABS.PRINT_HISTORY, printActivityResult]);

    if (printActivityResult.loading) {
        return <Loader></Loader>
    }

    if (printActivityResult.error) {
        return <div className="email-log-error">{t("ERROR_MESSAGES.PRINT_HISTORY_NOT_FOUND")}</div>
    }

    const onSUBSCDateChange = (date) => {
        const filtereData = Object.values(selectedDevicePrintHistoryArray).filter((val) => {
            return (val.startDate === date) ? val : "";
        });
        setIsDateFilterApplied(true);
        setPagesUsedData({
            planName: filtereData[0]?.planName,
            planPages: filtereData[0]?.planPages,
            printedPlanPages: filtereData[0]?.printedPlanPages,
            printedTotalPages: filtereData[0]?.printedTotalPages,
            printedRolloverPages: filtereData[0]?.printedRolloverPages,
            givenRolloverPages: filtereData[0]?.givenRolloverPages,
            printedOveragePages: filtereData[0]?.printedOveragePages,
            purchasedOveragePages: filtereData[0]?.purchasedOveragePages,
            printedBonusPages: filtereData[0]?.printedBonusPages,
            remainingBonusPages: filtereData[0]?.remainBonusPages
        });
    }

    return (
        <div className="mt-40">
            {
                printActivityResult?.success && (
                    <div className="user-print-history">
                        <div className="tab-btn-wrapper">
                            <div>
                                <Nav tabs>
                                    {(printActivityResult?.printActivity?.devicePrintHistory?.length > 0) ?
                                        printActivityResult?.printActivity?.devicePrintHistory.map((history) => (
                                            <NavItem>
                                                <NavLink active={activeTab === history.deviceId} onClick={() => {
                                                    setActiveTab(history.deviceId);
                                                    setSelectedDevicePrintHistoryArray(history.printHistory);
                                                    setIsDateFilterApplied(false);
                                                }}>
                                                    {history.serialNumber}
                                                </NavLink>
                                            </NavItem>
                                        )) :
                                        <NavItem>
                                            <NavLink active={activeTab === TABS.PRINT_HISTORY} onClick={() => {
                                                setActiveTab(TABS.PRINT_HISTORY);
                                                setSelectedDevicePrintHistoryArray(null);
                                                setIsDateFilterApplied(false);
                                            }}>
                                                {t('PRINT_ACTIVITY.PRINT_ACTIVITY_HEADER')}
                                            </NavLink>
                                        </NavItem>
                                    }
                                </Nav>
                            </div>
                        </div>
                        <div className="print-history-content-wrapper">
                            <TabContent activeTab={activeTab}>
                                {
                                    (printActivityResult?.printActivity?.devicePrintHistory?.length > 0) ?
                                        printActivityResult?.printActivity?.devicePrintHistory.map((history) => (
                                            <TabPane tabId={history.deviceId}>
                                                <div className={`print-activity-pages-used-wrapper displayed-as-child active-dashboard-blocks`}>
                                                    <h2 className="h2">{t("PRINT_ACTIVITY.PRINT_ACTIVITY_HEADER")}</h2>
                                                    {
                                                        (printActivityResult.success && !printActivityResult?.loading && history?.printHistory?.length > 0) ?
                                                            <>
                                                                <p className="body-medium pages-used-caption">{t("PRINT_ACTIVITY.PAGES_USED_LABELS.PAGES_USED")}</p>
                                                                {
                                                                    (!isDateFilterApplied) ?
                                                                        <PagesUsed
                                                                            planName={history?.printHistory[0]?.planName}
                                                                            planPages={history?.printHistory[0]?.planPages}
                                                                            printedPlanPages={history?.printHistory[0]?.printedPlanPages}
                                                                            printedTotalPages={history?.printHistory[0]?.printedTotalPages}
                                                                            printedRolloverPages={history?.printHistory[0]?.printedRolloverPages}
                                                                            givenRolloverPages={history?.printHistory[0]?.givenRolloverPages}
                                                                            printedOveragePages={history?.printHistory[0]?.printedOveragePages}
                                                                            purchasedOveragePages={history?.printHistory[0]?.purchasedOveragePages}
                                                                            printerType={history?.printerType}
                                                                            printedBonusPages={history?.printHistory[0]?.printedBonusPages}
                                                                            remainingBonusPages={history?.printHistory[0]?.remainingBonusPages}
                                                                            dateDropdownArr={Object.values(history?.printHistory).map((val) => { return val.startDate; })}
                                                                            dateFilter={onSUBSCDateChange}
                                                                            IS_CSAGENT={true}
                                                                            isChildComp={false}
                                                                        /> :
                                                                        <PagesUsed
                                                                            planName={pagesUsedData?.planName}
                                                                            planPages={pagesUsedData?.planPages}
                                                                            printedPlanPages={pagesUsedData?.printedPlanPages}
                                                                            printedTotalPages={pagesUsedData?.printedTotalPages}
                                                                            printedRolloverPages={pagesUsedData?.printedRolloverPages}
                                                                            givenRolloverPages={pagesUsedData?.givenRolloverPages}
                                                                            printedOveragePages={pagesUsedData?.printedOveragePages}
                                                                            purchasedOveragePages={pagesUsedData?.purchasedOveragePages}
                                                                            printerType={history?.printerType}
                                                                            printedBonusPages={pagesUsedData?.printedBonusPages}
                                                                            remainingBonusPages={pagesUsedData?.remainingBonusPages}
                                                                            dateDropdownArr={Object.values(history?.printHistory).map((val) => { return val.startDate; })}
                                                                            dateFilter={onSUBSCDateChange}
                                                                            IS_CSAGENT={true}
                                                                            isChildComp={false}
                                                                        />
                                                                }
                                                            </>
                                                            : <div className="email-log-error">{t("PRINT_ACTIVITY.NO_DATA_MSG")}</div>
                                                    }
                                                </div>
                                            </TabPane>
                                        )) :
                                        <TabPane tabId={TABS.PRINT_HISTORY}>
                                            <div className="email-log-error">{t("ERROR_MESSAGES.PRINT_HISTORY_NOT_FOUND")}</div>
                                        </TabPane>
                                }
                            </TabContent>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default EcoProPrintHistory;